import { CanDeactivateFn } from "@angular/router";
import { CanComponentDeactivate } from "../models";

export const unSavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (component) => {
  return component.canDeactivate ? component.canDeactivate() : true;
};
